<template>
    <div id="app">
        <header-bar></header-bar>
        <navbar :show="true" v-if="$route.path === '/'"></navbar>
        <navbar-admin :show="true" v-else></navbar-admin>
        <app-main></app-main>
        <footer-bar></footer-bar>
    </div>
</template>

<script>
  import { AppMain, FooterBar, HeaderBar, Navbar, NavbarAdmin } from './components/layout/'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      HeaderBar,
      Navbar,
      NavbarAdmin,
      AppMain,
      FooterBar,
    },

    beforeMount () {
      const {body} = document
      const WIDTH = 812
      const RATIO = 3

      const handler = () => {
        if (!document.hidden) {
          let rect = body.getBoundingClientRect()
          let isMobile = rect.width - RATIO < WIDTH
          this.toggleDevice(isMobile ? 'mobile' : 'other')
          this.toggleSidebar({
            opened: !isMobile
          })
        }
      }

      document.addEventListener('visibilitychange', handler)
      window.addEventListener('DOMContentLoaded', handler)
      window.addEventListener('resize', handler)
    },

    computed: mapGetters({
      sidebar: 'sidebar'
    }),

    methods: mapActions([
      'toggleDevice',
      'toggleSidebar'
    ])
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/App.vue